import { render, staticRenderFns } from "./PaymentTermViewLogs.vue?vue&type=template&id=582606f0"
import script from "./PaymentTermViewLogs.vue?vue&type=script&lang=js"
export * from "./PaymentTermViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports